export default {
  id: null,
  tipoTransporte: null,
  valor: null,
  inactive: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/kmvaluemodel.js